import "./styles/styles.scss";
import "./utils/hawkins.utils";
import { GlobalContext, GlobalContextType } from "./utils/GlobalContext.ts";
import { HelmetProvider } from "react-helmet-async";
import { Router } from "./components/utils/Router/Router.tsx";
import { HawkinsProvider } from "@hawkins/components/lib/hawkinsProvider/hawkinsProvider";

export const App = ({
  globalContext,
}: {
  globalContext: GlobalContextType;
}) => {
  return (
    <HawkinsProvider theme="dark">
      <GlobalContext.Provider value={globalContext}>
        <HelmetProvider>
          <Router />
        </HelmetProvider>
      </GlobalContext.Provider>
    </HawkinsProvider>
  );
};
